import { FetchNextPageOptions } from '@tanstack/react-query';
import { useState, useRef, useEffect } from 'react';
import { PostSkeleton } from './PostSkeleton';

type Props = {
  fetchNextPage: (
    options?: FetchNextPageOptions | undefined,
  ) => Promise<unknown>;
  isFetchingNextPage: boolean;
};

export const LoadMorePosts = ({ fetchNextPage, isFetchingNextPage }: Props) => {
  const [isVisibleInViewport, setVisibleInViewport] = useState(false);
  const loaderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setVisibleInViewport(entry.isIntersecting);
    });
    if (loaderRef?.current) observer.observe(loaderRef.current);

    return () => observer.disconnect();
  }, [loaderRef]);

  useEffect(() => {
    if (isVisibleInViewport && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [isVisibleInViewport, fetchNextPage, isFetchingNextPage]);

  return (
    <div ref={loaderRef}>
      <PostSkeleton />
    </div>
  );
};
